import React, { setGlobal, useEffect } from "reactn";

import Columns from "../../components/Columns";
import Container from "../../components/Container";
import Panel from "../../components/Panel";

const DataSheets = () => {
	useEffect(function () {
		(function () {
			setGlobal({ title: "Data Sheets" });
		})();
	}, []);

	const dataSheets = [
		{
			title: "Data Sheet",
			filePath: require("../../assets/files/data-sheet.pdf"),
		},
		{
			title: "Application Data Sheet",
			filePath: require("../../assets/files/application-data-sheet.pdf"),
		},
		{
			title: "Base Build Up Mesh and Go",
			filePath: require("../../assets/files/Base_Build_Up_BoundBase.pdf"),
		},
		{
			title: "Base Build Up Non Permeable Concrete",
			filePath: require("../../assets/files/Base_Build_Up_Non_Permeable_Concrete.pdf"),
		},
		{
			title: "Base Build Up Permeable Concrete",
			filePath: require("../../assets/files/Base_Build_Up_Permeable_Concrete.pdf"),
		},
		{
			title: "Base Build Up Tarmac",
			filePath: require("../../assets/files/Base_Build_Up_Tarmac.pdf"),
		},
		{
			title: "BoundBase Application Data Sheet",
			filePath: require("../../assets/files/BoundBase_Application_Data_Sheet.pdf"),
		},
		{
			title: "BoundBase Application Data Sheet Marble",
			filePath: require("../../assets/files/BoundWorx_Application_Data_Sheet_MARBLE.pdf"),
		},
		{
			title: "BoundBase Data Sheet Marble",
			filePath: require("../../assets/files/BoundWorx_Data_Sheet_MARBLE.pdf"),
		},
		{
			title: "BoundWorx Data Sheet",
			filePath: require("../../assets/files/BoundWorx_Data_Sheet.pdf"),
		},
		{
			title: "BoundWorx Easy Trowel Data Sheet",
			filePath: require("../../assets/files/BoundWorx_Easy_Trowel_Data_Sheet.pdf"),
		},
		{
			title: "BoundWorx Maintenance",
			filePath: require("../../assets/files/BoundWorx_Maintenance.pdf"),
		},
		{
			title: "BoundWorx Part A SDS",
			filePath: require("../../assets/files/BoundWorx_Part_A_SDS.pdf"),
		},
		{
			title: "BoundWorx Part B SDS",
			filePath: require("../../assets/files/BoundWorx_Part_B_SDS.pdf"),
		},
		{
			title: "BoundWorx Resin Bound Guarantee",
			filePath: require("../../assets/files/BoundWorx_Resin_Bound_Guarantee.pdf"),
		},
	];

	return (
		<Container>
			<Columns>
				{dataSheets.map((dataSheet, index) => (
					<Panel key={`data-sheet--${index}`} variant="white">
						<a href={dataSheet.filePath}>
							<Panel.Title>{dataSheet.title}</Panel.Title>
							<Panel.Body>
								<Panel.Image
									src={require("../../assets/vectors/data-sheets.svg")}
								/>
							</Panel.Body>
						</a>
					</Panel>
				))}
			</Columns>
		</Container>
	);
};

export default DataSheets;
